

















































































import {
  Vue, Component, Prop, Emit,
} from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import RuleScriptParameter from '@/domain/scripts/entity/rule-script-parameter.entity';
import Rules from '@/shared/rules/rules';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import Parameters from './parameter-type.json';

@Component({
  components: {
    LabelSlot,
    VbTooltipSlot,
  },
})
export default class ParameterDefinition extends Vue {
  @Prop({
    required: true,
  })
  parameter!: RuleScriptParameter;

  @Prop({
    required: true,
  })
  businessUnitId!: string;

  @Prop({
    required: true,
    default: false,
  })
  previewModeValue!: boolean;

  @Prop({
    required: true,
  })
  indexComponent!: number;

  rules: Rules = new Rules();

  parameters = Parameters;

  indexParameter():number {
    if ((this.parameter.index === undefined) || (this.parameter.index == null)) {
      this.parameter.index = this.indexComponent;
    }
    return this.parameter.index + 1;
  }

  get parameterName(): string {
    return this.parameter.name;
  }

  set parameterName(value: string) {
    this.parameter.name = value.replace(/\s/g, '');
  }

  insertToScript() {
    if (!this.parameter.name) {
      VbSnackbarService.showError('Informe o nome do parâmetro antes de inserir no script');
      return;
    }
    this.$emit('insertToScript', this.parameter);
  }
}
